import styled from "styled-components";

const RateStyles = styled.div`
  .evaluate {
    &__block-1 {
      padding-top: 60px;
      height: 780px;
      width: 100%;
      background: url("https://i.imgur.com/KnsYwD1.png");
      background-position: center 30%;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &__header-2 {
      font-family: $header-font !important;
      font-weight: normal !important;
      font-size: 30px;
      color: $off-black;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 20px;
    }

    &__body-copy {
      font-family: $body-font;
      font-size: 22px;
      color: $off-black;
      text-align: center;
      margin: 0 auto;
      line-height: 36px;
      width: 550px;

      &-2 {
        font-family: $body-font;
        font-size: 30px;
        color: $off-black;
        text-align: center;
        margin: 0 auto;
        // margin-top: 40px;
        line-height: 42px;
        width: 350px;
      }
    }

    &__block-2 {
      padding-top: 60px;
      height: 880px;
      background: #ebedec;
      width: 100%;
    }

    &__screenshots {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: center;

      &-item {
        height: 600px;
        margin-right: 60px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &__block-3 {
      padding-top: 60px;
      height: 780px;
      background: url("https://i.imgur.com/hwaY8v5.jpg");
      background-position: center 55%;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
    }

    &__block-4 {
      padding-top: 60px;
      height: 780px;
      background: url("https://i.imgur.com/6XyUOZ1.jpg");
      background-position: center 55%;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &__first-section {
      position: relative;

      &-container {
        width: 100%;
        padding: 0px 80px 60px;
      }

      background: white;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 100%;
    }
  }

  .iframe-container {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
  }

  .iframe-container iframe {
    border: 0;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  @media only screen and (max-width: 1175px) {
    .evaluate {
      &__screenshots {
        &-item {
          margin-right: 20px;

          &:last-child {
            margin-right: 0;
            margin-bottom: 40px;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1075px) {
    .evaluate {
      &__block-1 {
        padding: 60px 20px 0;
      }

      &__body-copy {
        width: 100%;
        max-width: 550px;

        &-2 {
          width: 100%;
          max-width: 350px;
        }
      }

      &__block-2 {
        padding: 60px 20px 0;
        height: auto;
      }

      &__screenshots {
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        &-item {
          margin-right: 0;
        }
      }

      &__block-3 {
        padding: 60px 20px 0;
      }

      &__block-4 {
        padding: 60px 20px 0;
      }

      &__first-section {
        position: relative;

        &-container {
          padding: 0px 20px 60px;
        }
      }
    }
  }

  @media only screen and (max-width: 1075px) and (pointer: coarse) {
    .evaluate {
      &__block-1 {
        padding: 50px 14px 0;
        height: 800px;
        background-position: center top;
      }

      &__header-2 {
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 20px;
      }

      &__body-copy {
        font-size: 20px;
        line-height: 30px;
        width: 100%;
        max-width: 550px;

        &-2 {
          font-size: 28px;
          line-height: 36px;
          width: 100%;
        }
      }

      &__block-2 {
        padding: 50px 14px 0;
        height: auto;
      }

      &__screenshots {
        padding-top: 20px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        &-item {
          margin-right: 0;
        }
      }

      &__block-3 {
        padding: 50px 14px 0;
        height: 720px;
        background-position: center 55%;
      }

      &__block-4 {
        padding: 50px 14px 0;
        height: 540px;
        background-position: center 55%;
      }

      &__first-section {
        position: relative;

        &-container {
          padding: 0px 12px 60px;
        }
      }
    }
  }
`;

export default RateStyles;
